/**
 * Small, non-visual accessibility repairs for global and third-party UI.
 *
 * @package ow-features
 */

( function () {
	'use strict';

	function repairHubSpotRoles( root ) {
		if ( ! root.querySelectorAll ) {
			return;
		}

		root.querySelectorAll( '.hs-form ul[role="checkbox"], .hs-form li[role="checkbox"]' ).forEach( function ( item ) {
			item.removeAttribute( 'role' );
		} );
	}

	function setupMenuState() {
		var button = document.querySelector( '.header-nav-menu-btn' );
		if ( ! button ) {
			return;
		}

		button.addEventListener( 'click', function () {
			window.requestAnimationFrame( function () {
				button.setAttribute( 'aria-expanded', button.classList.contains( 'is-active' ) ? 'true' : 'false' );
				button.setAttribute( 'aria-label', button.classList.contains( 'is-active' ) ? 'Close navigation menu' : 'Open navigation menu' );
			} );
		} );
	}

	function boot() {
		repairHubSpotRoles( document );
		setupMenuState();

		if ( 'MutationObserver' in window ) {
			new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					mutation.addedNodes.forEach( function ( node ) {
						if ( node.nodeType === 1 ) {
							repairHubSpotRoles( node );
						}
					} );
				} );
			} ).observe( document.body, { childList: true, subtree: true } );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}
} )();
